// libs
import { makeObservable, observable } from 'mobx';
// dirty
import { mapUI, mapWrapper } from '../../map';
import { MassGridLayer } from './MassGridLayer'; // todo remove dependency
// pure
import { ModelsLayer } from '@openlayers/models/ModelsLayer';
import { Ajax } from '@shared/Ajax';
import { Notify } from '@shared/ui-native/Notify';
// ol
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';


/**
 * @author NikolaV
 */

export class MassMap {
    @observable loading = false;
    @observable showLabels = false;
    @observable showCrossSectionLines: boolean = false;

    @observable.ref
    public activeGridLayer: MassGridLayer = null;
    @observable.ref
    public activeGridSheet = null;

    last = {
        cellWidth: null,
        rotation: null,
        modelsSource: null,
    };

    constructor(
        private readonly modelsLayer: ModelsLayer
    ) {
        makeObservable(this);
    }

    destroy = () => {
        this.modelsLayer.layerSource.un('removefeature', this.checkValidity);
    }

    clearMap = () => {
        if (this.activeGridLayer) {
            this.activeGridLayer.destroy();
            this.activeGridLayer = null;
            this.activeGridSheet = null;
        }
    }

    openSheet(sheet: Mass.Sheets) {
        const {
            model1Id: calculationLayerId,
            model2Id: referenceLayerId,
            model3Id: limitLayerId
        } = sheet;

        const modelIds: number[] = [calculationLayerId, referenceLayerId, limitLayerId]
            .filter(id => !!id && id > 0);

        this.loading = true;
        $.when(this.fetchCalculation(sheet.id), ...modelIds.map(this.drawAndCheckModel))
            .done((calculationResponse, ...models) => {
                const calc = calculationResponse[0];
                this.clearMap();

                const modelFeatures: Feature[] = modelIds.map(modelId => mapWrapper.featureLayers.models.getFeaturesBySource({ modelId })[0]);
                const modelsSource = new VectorSource();
                try {
                    modelsSource.addFeatures(modelFeatures.filter(Boolean));
                } catch (e) {
                    console.warn('Same model added twice');
                }
                mapWrapper.fitFeatures(modelFeatures);

                if (sheet.type === 'AREA') {
                    this.openAreaSheet(sheet, modelsSource, calc);
                }
                else if (sheet.type === 'SIMPLE') {

                }
                else if (sheet.type === 'ADVANCE') {

                }
            })
            .fail(Notify.error)
            .always(() => this.loading = false);
    }

    fetchCalculation(sheetId: number) {
        return Ajax({
            url: 'api/1/mass/sheet/' + sheetId + '.json'
        }).done(task => {
            console.log('task:', task);
        });
    }

    toggleLabels = () => {
        this.showLabels = !this.showLabels;
        if (this.activeGridLayer) {
            this.activeGridLayer.setLabels(this.showLabels);
            this.activeGridLayer.draw(this.last.cellWidth, this.last.rotation, this.last.modelsSource);
        }
    }

    toggleCrossSectionLines = () => {
        this.showCrossSectionLines = !this.showCrossSectionLines;
        if (this.activeGridLayer) {
            this.activeGridLayer.setCrossSectionLines(this.showCrossSectionLines);
            this.activeGridLayer.draw(this.last.cellWidth, this.last.rotation, this.last.modelsSource);
        }
    }

    private readonly openAreaSheet = (sheet: Mass.SheetArea, modelsSource: VectorSource, calc: Mass.AreaCalculation) => {
        this.clearMap();
        this.activeGridSheet = sheet;
        this.activeGridLayer = new MassGridLayer(mapWrapper.getInstance(), calc, this.showLabels, this.showCrossSectionLines);
        const { rotation, cellWidth } = sheet.externalData;
        this.activeGridLayer.draw(cellWidth, rotation, modelsSource);

        this.last = {
            cellWidth, rotation, modelsSource
        };
    };

    private readonly openSimpleSheet = (sheet: Mass.SheetSimple, models: Feature[]) => {

    };

    private readonly openAdvancedSheet = (sheet: Mass.SheetAdvanced, models: Feature[]) => {

    };

    private readonly drawAndCheckModel = (modelId: number) => {
        return this.modelsLayer.fetchAndDrawFile(modelId).then(r => {
            mapUI.mapPanels.panels.models.checkItem(modelId);
        });
    };

    private readonly checkValidity = e => {
        // when model is removed from map, also remove mass visualizations that depend on that model
        console.log('e:', e);
    };
}
